$(document).on('change', '#preferences input', function(e){
  this.closest('form').submit();
});
